import { priceFormat } from '@apps/utils/format-price';
import Chip from '@mui/material/Chip';

import { SoldChipProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const SoldChip: React.FC<SoldChipProps> = (props) => {
  const { label, postfix, ...rest } = props;

  // ============ VIEWS
  return (
    <Chip
      variant={'filled'}
      label={`${priceFormat({ price: label ?? '0', postfix: ` ${postfix}` })}`}
      {...rest}
      sx={{ span: { padding: 0 }, ...rest?.sx }}
      style={{
        borderRadius: 4,
        padding: '2px 8px',
        width: 'auto',
        height: 'auto',
        fontSize: '12px',
        fontWeight: 700,
        ...rest?.style,
      }}
    />
  );
};

/**
 * ===========================
 * EXPORT
 * ===========================
 */
export default SoldChip;
